import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { TitleService } from '../../core/services/title.service';

@Injectable({ providedIn: 'root' })
export class ApplicationSubmittedTitleResolver implements Resolve<string> {
  constructor(private title: TitleService) {}
  resolve(): string {
    const t = 'Application Submitted';
    this.title.setTitle(t);
    return t;
  }
}
